// @ts-expect-error marker is exported but only from the web package
import MapView, { Marker } from "@teovilla/react-native-web-maps";
export { MapView, Marker };
